const websiteVersion = process.env.NODE_ENV === 'development' ? '' : '598b6de'

export default websiteVersion
